import { Table } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import TableAntd from "components/elements/Table/Table";

const EmployeeHolidayTable = ({
    isLoading = false,
    pagination = {},
    dataSource = [],
    onEdit = () => { },
    onDelete = () => { },
    onStatus = () => { },
    onChange = () => { },
}) => {
    // const isLoading = useSelector((state) => state.holidayCalendar.isLoading);
    console.log("employee ", dataSource);
    const { t, i18n } = useTranslation();

    function formatDateTime(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD MMMM ${date.year() + 543} เวลา HH:mm น.`);
    }

    const columns = [
        {
            title: <div className="text-table">{t('salary.label.employee_no')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            sorter: {
                compare: (a, b) => {
                    return (a.employeeNo || '').localeCompare(b.employeeNo || '');
                },
            },
            width: 200
        },
        {
            title: <div className="text-table">{t('employee.label.employee-name')}</div>,
            dataIndex: "employeeName",
            key: "employeeName",
            render: (_, record) => {
                if (record?.nameEn || record?.name) {
                    return i18n.language === 'en' ? record?.nameEn + " " + record?.surnameEn : record?.name + " " + record?.surname
                }

            }
        },
        {
            title: <div className="text-table">{t('employee.label.date_added-to-list')}</div>,
            dataIndex: "calendarAddDate",
            key: "calendarAddDate",
            render: (_, record) => {
                return formatDateTime(record?.calendarAddDate)
            }

        },


    ];

    return (
        <TableAntd
            loading={isLoading}
            pagination={false}
            dataSource={dataSource}
            rowKey={(record) => record?.employeeId}
            columns={columns}
            onChange={onChange}
            scroll={{ x: true }}
        />
    );
};

export default EmployeeHolidayTable;
